import React from 'react'
import { setDisableAppHeaderRender } from '@core/Areas/AppHeader/Store'
import { useAppDispatch } from '@core/Store/hooks'

/** Only to be used on top level page routes - otherwise changes required */
export const useDisableAppHeaderRender = () => {
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    dispatch(setDisableAppHeaderRender(true))
    return () => {
      dispatch(setDisableAppHeaderRender(false))
    }
  }, [dispatch])
}
